import axios from "axios";
import { getHeaders } from '../helpers';
import { getChestApiUrl } from "../../helpers";


/**
 * Get all Countries.
 * 
  */
const getCountries = () => axios.get(`${getChestApiUrl()}/chestApi/countries`, { headers: getHeaders() })


export default { getCountries }